import { useEffect, useState } from "react";

const useDeviceSize = () => {
  const [deviceWidth, setWidth] = useState(0);
  const [deviceHeight, setHeight] = useState(0);

  const handleWindowResize = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };

  useEffect(() => {
    handleWindowResize();
    window.addEventListener("resize", handleWindowResize);

    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return [deviceWidth, deviceHeight];
};

export default useDeviceSize;
